import { EmptyState } from 'app/agriculture/components/EmptyState/EmptyState';
import { TaskListMonthView } from 'app/agriculture/routes/Tasks/TaskList/components/TaskListMonthView/TaskListMonthView';
import { TaskListUserView } from 'app/agriculture/routes/Tasks/TaskList/components/TaskListUserView/TaskListUserView';
import { Task } from 'app/agriculture/queries/tasks/types/Task';

export type TaskListGroupMode = 'Month' | 'User';

interface TaskListComponentProps {
    tasks: Task[];
    hasFilterApplied?: boolean;
    groupMode: TaskListGroupMode;
}

export function TaskListComponent({
    tasks,
    hasFilterApplied = false,
    groupMode,
}: TaskListComponentProps) {
    return (
        <div className="TaskListComponent">
            {tasks.length === 0 && (
                <EmptyState
                    message={
                        hasFilterApplied
                            ? 'Your search returned no results'
                            : 'There are currently no tasks'
                    }
                />
            )}
            {groupMode === 'Month' && <TaskListMonthView tasks={tasks} />}
            {groupMode === 'User' && <TaskListUserView tasks={tasks} />}
        </div>
    );
}
